/* KOSMA search overlay — simple vanilla JS toggle (no custom elements) */
(function () {
  function init() {
    var overlay = document.getElementById('kosma-search-overlay');
    if (!overlay) return;
    var input = overlay.querySelector('.kosma-search__input');
    var triggers = document.querySelectorAll('.kosma-search-trigger');
    var lastFocus = null;

    function open() {
      if (overlay.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('kosma-search-open');
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
      });
      window.setTimeout(function () {
        if (input) input.focus();
      }, 80);
    }

    function close() {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('kosma-search-open');
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (overlay.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });
    });

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-kosma-search-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });

    window.KosmaSearch = { open: open, close: close };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
